import { ThreeDots } from "react-loader-spinner";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { ReactComponent as RecoEngineIcon } from "../assets/reco-engine-icon.svg";
import { handleRedirect } from "../../../utils/CommonFunctions";
import { createLinkParser } from "../services";

interface ChatBlockProps {
  text?: string;
  engineResponse?: boolean;
  loading?: boolean;
}

const ChatBlock = ({ text, engineResponse, loading }: ChatBlockProps) => {
  const [t] = useTranslation("translations");
  const history = useNavigate();
  const parseWithLinks = createLinkParser(handleRedirect, history, "RECO_ENGINE");
  const doesTextIncludeReasoning = text?.includes("Reasoning:");
  const overViewText = text?.split("Reasoning:")[0];

  return (
    <div className="recoEngine__chat_container">
      {engineResponse ? <RecoEngineIcon aria-label="Engine Response Icon" /> : null}
      {loading ? (
        <div className="recoEngine__chat engine_chat three_dots">
          <ThreeDots
            visible
            height="8"
            width="8"
            color="rgba(221, 229, 237, 1)"
            radius="9"
            ariaLabel="three-dots-loading"
            wrapperStyle={{}}
            wrapperClass=""
          />
        </div>
      ) : (
        doesTextIncludeReasoning ? (
          <div className="recoEngine__chat_multiple">
            <div
              className="recoEngine__chat engine_chat"
              aria-label={engineResponse ? "Engine Response" : "User Message"}
            >
              {parseWithLinks(overViewText)}
            </div>
            <div
              className="recoEngine__chat engine_chat"
              aria-label={engineResponse ? "Engine Response" : "User Message"}
            >
              {t("RecoSearch.scrolling_message")}
            </div>
            <div
              className="recoEngine__chat engine_chat"
              aria-label={engineResponse ? "Engine Response" : "User Message"}
            >
              {parseWithLinks(t("RecoSearch.location_permission_message"))}
            </div>
        </div>
        ) : (
          <div
            className={`recoEngine__chat ${engineResponse ? "engine_chat" : "user_chat"}`}
            aria-label={engineResponse ? "Engine Response" : "User Message"}
          >
            {parseWithLinks(text)}
          </div>
        )
      )}
    </div>
  )
};

export default ChatBlock;
